export const getLocalStorageItem = (key: string): unknown | null => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    console.error(`Error getting item from localStorage: ${key}`, error);
    return null;
  }
};

export const setLocalStorageItem = (key: string, value: unknown): void => {
  try {
    if (value !== undefined && value !== null) {
      localStorage.setItem(key, JSON.stringify(value)); // Store as a string
    }
  } catch (error) {
    console.error(`Error setting item to localStorage: ${key}`, error);
  }
};

export const removeLocalStorageItem = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing item from localStorage: ${key}`, error);
  }
};

export const clearLocalStorage = (): void => {
  try {
    localStorage.clear();
  } catch (error) {
    console.error("Error clearinglocalStoragez", error);
  }
};
